var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('videoPlayer',{ref:"videoPlayer",staticClass:"video-player-box",attrs:{"options":_vm.playerOptions,"playsinline":true},on:{"statechanged":function($event){return _vm.playerStateChanged($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }